import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { class: "input-group cursor-default" }
const _hoisted_5 = { class: "col-6" }
const _hoisted_6 = { class: "input-group cursor-default" }
const _hoisted_7 = {
  key: 0,
  class: "date-range-error alert alert-danger py-1 px-2 mb-0 mt-1 small d-flex align-items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.errorMessage !== null}]),
            ref: "startDateInput",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filledStartDateValue) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onStartDateChange && _ctx.onStartDateChange(...args)))
          }, null, 34), [
            [_vModelText, _ctx.filledStartDateValue]
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "input-group-text" }, [
            _createElementVNode("i", { class: "fas fa-calendar-alt" })
          ], -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.errorMessage !== null}]),
            ref: "endDateInput",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filledEndDateValue) = $event)),
            onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onEndDateChange && _ctx.onEndDateChange(...args)))
          }, null, 34), [
            [_vModelText, _ctx.filledEndDateValue]
          ]),
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "input-group-text" }, [
            _createElementVNode("i", { class: "fas fa-calendar-alt" })
          ], -1))
        ])
      ])
    ]),
    (_ctx.errorMessage !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}